import { getHttpClient, LoginApi, PaymentApi, VtManagementApi } from '@capsicum/common';

export const loginApi = getHttpClient.then(c => new LoginApi(c));
export const paymentApi = getHttpClient.then(c => new PaymentApi(c));
export const fanTokenOfferingApi = getHttpClient.then(c => new VtManagementApi(c));
